var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBoxImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 232,
    viewBox: "0 0 286 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M242.174 68.4441L143.176 95.0106L43.9011 68.4442L143.176 50.5635L242.174 68.4441Z",
    fill: "#565656",
    stroke: "#565656",
    strokeWidth: 6,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.693 3H81.6914V32.0412H110.693V3Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.693 103.376H81.6914V132.417H110.693V103.376Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M211.564 3H182.562V32.0412H211.564V3Z",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.39 22.5693V56.026H81.0615V83.1716",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.604 4.26562H157.345V37.7223",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M210.303 50.9746V91.378H176.262",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M181.939 72.4446V56.0312H157.983V79.3913H134.656V104.641H157.983V138.098",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M210.939 137.463V115.998H181.308V138.093",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M134.656 121.049V137.463",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3477 78.7559H116.369",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M255.253 179.745L142.862 228.72V98.1165L255.883 67.8716L255.253 179.745Z",
    fill: "#565656",
    stroke: "#434343",
    strokeWidth: 6,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7862 179.745L143.177 228.72V98.1165L30.1562 67.8716L30.7862 179.745Z",
    fill: "#565656",
    stroke: "#434343",
    strokeWidth: 6,
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M283 105.727L170.019 135.792L143.02 98.1164L256.001 68.0571L283 105.727Z",
    fill: "#565656",
    stroke: "#434343",
    strokeWidth: 6,
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M142.98 98.1164L29.9994 68.0571L3 105.727L115.981 135.792L142.98 98.1164Z",
    fill: "#565656",
    stroke: "#434343",
    strokeWidth: 6,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxImage);
export default __webpack_public_path__ + "static/media/boxImage.96223b2a0aedea353de1a8eb28c0de05.svg";
export { ForwardRef as ReactComponent };